import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { type ReactNode, useContext, useEffect } from 'react';

import {
  NestedFilterSelectGroupContext,
  useNestedFilterSelectContext,
} from './context';
import styles from './nested-filter-select.module.css';

type NestedFilterSelectItemProps = {
  value: string;
  label: string;
  children?: ReactNode;
};

export function NestedFilterSelectItem({
  value,
  label,
  children,
}: NestedFilterSelectItemProps) {
  const { selectedValue, onSelectValue, registerValueGroup } =
    useNestedFilterSelectContext();
  const groupLabel = useContext(NestedFilterSelectGroupContext);
  const isSelected = value === selectedValue;

  useEffect(() => {
    registerValueGroup(value, groupLabel);
  }, [value, groupLabel, registerValueGroup]);

  return (
    <DropdownMenu.Item
      className={styles.item}
      data-selected={isSelected ? 'true' : undefined}
      data-testid={`data-builder-custom-filter-option-${value}`}
      onSelect={() => {
        onSelectValue(value, groupLabel);
      }}
    >
      <span className={styles.itemLabel}>{label}</span>
      {children !== undefined && children !== null ? (
        <span className={styles.endSlot}>{children}</span>
      ) : null}
    </DropdownMenu.Item>
  );
}
